import { startsWith } from 'lodash'
import IMask from 'imask'
import trim from 'lodash/trim'

const isNumber = (value) => {
  return /^\d+$/.test(value)
}

export const phone = (value) => {
  // Mobile 1
  if (value) {
    const pattern1 = '+63 '
    if (startsWith(value, pattern1)) {
      const rest = value.replace(pattern1, '')
      // Check number
      if (isNumber(rest) === false) {
        return false
      }

      // Check length
      if (rest.length !== 10) {
        return false
      }

      return true
    }

    // Mobile 2
    const pattern2 = '09'
    if (startsWith(value, pattern2)) {
      const rest = value.replace(pattern2, '')

      // Check number
      if (isNumber(rest) === false) {
        return false
      }

      if (rest.length !== 9) {
        return false
      }

      return true
    }

    // The rest
    const parts = value.split('-')

    if (parts.length !== 3) {
      return false
    }

    if (parts.some((x) => !isNumber(x))) {
      return false
    }

    if (
      parts[0].length !== 2 ||
      parts[1].length !== 4 ||
      parts[2].length !== 4
    ) {
      return false
    }
  }
  // Every ok
  return true
}

export const getPhoneMaxLength = (value) => {
  if (startsWith(value, '+') || startsWith(value, '09')) {
    return 24
  }

  return 30
}

export const normalizePhoneNumber = (phone) => {
  let mask = '00-0000-0000'

  if (startsWith(phone, '+')) {
    mask = '+00 0000000000'
  }

  if (startsWith(phone, '09')) {
    mask = '00000000000'
  }

  const phoneMasker = IMask.createMask({
    mask,
  })
  return phoneMasker.resolve(phone)
}

export const strongPassword = (value) => {
  // Null
  if (!value) {
    return false
  }

  // Min len < 9
  if (value.length < 9) {
    return false
  }

  // No lowercase
  if (!value.match(/[a-z]/)) {
    return false
  }

  // No uppercase
  if (!value.match(/[A-Z]/)) {
    return false
  }

  // No number
  if (!value.match(/[0-9]/)) {
    return false
  }

  // No special chars
  const specialChars = [
    '`',
    '~',
    '#',
    '^',
    '(',
    ')',
    '-',
    '_',
    '=',
    '+',
    '[',
    ']',
    '{',
    '}',
    ';',
    ':',
    "'",
    '"',
    '\\',
    '|',
    ',',
    '<',
    '>',
    '.',
    '/',
    '!',
    '@',
    '$',
    '%',
    '&',
    '*',
    '?',
  ]
  if (specialChars.every((char) => !value.includes(char))) {
    return false
  }

  // Ok
  return true
}

export const checkEmptyValue = (value) => {
  if (trim(value) === '') {
    return false
  }

  return true
}
